import axios from "axios";
import { SWNEWS_HOST, NEWS_HOST } from "../../constants/apiHosts";


const state = () => ({
  activeIndex: "",
  menuFresh: false,
  product: {},
  userId: null,
  userInfo: {},
  unReadNum: 0,
  unReadArray: [0, 0, 0, 0]
})

const getters = {
  getUserId: state => state.userId,
  getUnReadArray: state => state.unReadArray
}

const actions = {
  // 获取用户信息
  getUserInfo: async function ({ commit }) {
    const { data } = await axios.get(`${SWNEWS_HOST}/api/user/mpBaseUserinfo`)
    localStorage.setItem('u_id', data.data.u_id)
    localStorage.setItem('u_nickname', data.data.u_nickname)
    localStorage.setItem('u_avatar', data.data.u_avatar)
    localStorage.setItem('is_reverse_author', data.data.is_reverse_author)
    let u_cert = 0, u_cert_status = 0;
    data.data.identities_info.forEach(element => {
      if (element == "identity_verification") {
        u_cert = 1
      }
      if (element == "agency_certification" || element == "professional_certification") {
        u_cert_status = 1
      }
    });
    localStorage.setItem('u_cert', u_cert)
    localStorage.setItem('u_cert_status', u_cert_status)
    localStorage.setItem('cert_type', data.data.u_cert.cert_type)
    commit('setUserInfo', {
      u_nickname: data.data.u_nickname,
      u_avatar: data.data.u_avatar,
      u_id: data.data.u_id
    })
  },
  // 获取未读消息数量
  getUnReadNum: async function ({ commit }) {
    const data1 = await axios.get(`${NEWS_HOST}/api/notice/getMpNoReadNums?type=0`)
    const data2 = await axios.get(`${NEWS_HOST}/api/notice/getMpNoReadNums?type=1`)
    const data3 = await axios.get(`${SWNEWS_HOST}/api/notice/getCommunityNoReadNums`)
    const data4 = await axios.get(`${NEWS_HOST}/api/notice/getTypeNums`)
    let count = data1.data.data.count + data2.data.data.count + data3.data.data.count + data4.data.data.xt_auth.noread;
    if (data1.data.data.count == "99+" || data2.data.data.count == "99+" || data3.data.data.count == "99+" || data4.data.data.xt_auth.noread == "99+") {
      count = "99+";
    } else if (count > 99) {
      count = "99+";
    }
    commit('setUnReadNum', count)
    commit('setUnReadArray', [data1.data.data.count, data2.data.data.count, data3.data.data.count, data4.data.data.xt_auth.noread])
  }
}

const mutations = {
  setUserId: (state, userId) => {
    state.userId = userId
  },
  // 设置用户信息
  setUserInfo: (state, userInfo) => {
    state.userInfo = userInfo
  },
  // 设置未读消息
  setUnReadNum: (state, unReadNum) => {
    state.unReadNum = unReadNum
  },
  setUnReadArray: (state, unReadArray) => {
    state.unReadArray = unReadArray
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}